import styles from './LandingLayout.module.css';

import classNames from 'classnames';

import LogoIcon from '../assets/icons/logo.svg?react';
import type { FC, PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

export const LandingLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.outerWrapper}>
      <div className={styles.blueCard}>
        <header className={styles.header}>
          <a href="https://mypax.ru" target="_blank" rel="noopener noreferrer">
            <div className={styles.logo}>
              <LogoIcon />
            </div>
          </a>

          <div className={styles.navLinks}>
            <Link to="https://mypax.ru" className={styles.link}>
              Как это работает
            </Link>
            <Link to="https://mypax.ru" className={styles.link}>
              Отзывы
            </Link>
            <Link to="https://mypax.ru" className={styles.link}>
              Помощь
            </Link>
          </div>

          <div className={styles.authButtons}>
            <Link to="/client/login" className={styles.link}>
              Войти
            </Link>
            <Link
              to="/client/register"
              className={classNames(styles.registerButton)}
            >
              Зарегистрироваться
            </Link>
          </div>
        </header>

        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};
